import api from 'ApiConfig';

const batchTeacherStructureService = {
  getBatchStructuresByCourse: async (courseId) =>
    api.post(`/teacher/get-batch-structures-by-course/${courseId}`),

  getBatchesByCourseStructure: async (
    courseId,
    batchStructureId,
    selectedBranch,
    excludeAssigned = false
  ) => {
    return api.post('/teacher/get-batches-by-course-structure', {
      courseId,
      batchStructureId,
      selectedBranch,
      excludeAssigned,
    });
  },
};
export default batchTeacherStructureService;
